export default {
  "save-item-as-product-success": {
    EN: "Saved to worksheet products",
  },
  "save-item-as-product-failure": {
    EN: "Failed to save worksheet product",
  },
  "create-product-success": {
    EN: "Worksheet product created",
  },
  "create-product-failure": {
    EN: "Failed to create worksheet product",
  },
  "update-product-success": {
    EN: "Worksheet product saved",
  },
  "update-product-failure": {
    EN: "Failed to save worksheet product",
  },
  "delete-product-success": {
    EN: "Worksheet product deleted",
  },
  "delete-product-failure": {
    EN: "Failed to delete worksheet product",
  },
  "duplicate-product-success": {
    EN: "Worksheet product duplicated",
  },
  "duplicate-product-failure": {
    EN: "Failed to duplicate worksheet product",
  },
  "create-item-success": {
    EN: "Worksheet item added",
  },
  "create-item-failure": {
    EN: "Failed to add worksheet item",
  },
  "update-item-success": {
    EN: "Worksheet item saved",
  },
  "update-item-failure": {
    EN: "Failed to save worksheet item",
  },
  "update-estimating-method-success": {
    EN: "Estimating method updated",
  },
  "update-estimating-method-failure": {
    EN: "Failed to update estimating method",
  },
};
